module.exports = __webpack_public_path__ + "assets/wego-logo-big.8537a35f5d63d7ae801efb8f138093cc.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/wego-logo-big.png
// module id = 621
// module chunks = 2